export default [
  {
    name: "UserProfile",
    path: "/user-profile",
    component: () => import("@/views/UserProfile"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
      title: "Informações do usuário",
    },
  },
  {
    name: "ErpIntegrationView",
    path: "/erp-integration-run",
    component: () => import("@/views/ErpIntegrationView.vue"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  // ACCOUNT
  {
    name: "AccountGroupVersion",
    path: "/account-group-version",
    component: () => import("@/views/AccountGroupVersion"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "AccountGroupSystemId",
    path: "/account-group-system-id",
    component: () => import("@/views/AccountGroupSystemId"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "AccountGroup",
    path: "/account-group",
    component: () => import("@/views/AccountGroup"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  // CONSOLIDATION KEY
  {
    name: "ConsolidationKey",
    path: "/consolidation-key",
    component: () => import("@/views/ConsolidationKey"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "ConsolidationKeyType",
    path: "/consolidation-key-type",
    component: () => import("@/views/ConsolidationKeyType"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },

  //EVENT
  {
    name: "Event",
    path: "/event",
    component: () => import("@/views/Event"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "EventStatusByUser",
    path: "/event-status-by-user",
    component: () => import("@/views/EventStatusByUser"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  // REGISTER
  {
    name: "Bank",
    path: "/bank",
    component: () => import("@/views/Bank"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "BankAccountType",
    path: "/bank-account-type",
    component: () => import("@/views/BankAccountType"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowFavoredType",
    path: "/cash-flow-favored-type",
    component: () => import("@/views/CashFlowFavoredType"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowFavored",
    path: "/cash-flow-favored",
    component: () => import("@/views/CashFlowFavored"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowCategoryType",
    path: "/cash-flow-category-type",
    component: () => import("@/views/CashFlowCategoryType"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowTransfer",
    path: "/cash-flow-transfer",
    component: () => import("@/views/CashFlowTransfer"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowCategory",
    path: "/cash-flow-category",
    component: () => import("@/views/CashFlowCategory"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowAccountCategory",
    path: "/cash-flow-account-category",
    component: () => import("@/views/CashFlowAccountCategory"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "BankAccountInitialBalance",
    path: "/bank-account-initial-balance",
    component: () => import("@/views/BankAccountInitialBalance"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "BankAccountBalance",
    path: "/bank-account-balance",
    component: () => import("@/views/BankAccountBalance"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowValue",
    path: "/cash-flow-value",
    component: () => import("@/pages/cash-flow-value/CashFlowValueView.vue"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  // {
  //   name: "CashFlowValue",
  //   path: "/cash-flow-value",
  //   component: () => import("@/views/CashFlowValue.vue"),
  //   meta: {
  //     requireAuth: true,
  //     redirectHomeIfLogged: false,
  //   }
  // },
  {
    name: "CashFlowValue2",
    path: "/cash-flow-value2",
    component: () => import("@/views/CashFlowValue2"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowPrevision",
    path: "/cash-flow-prevision-value",
    component: () =>
      import("@/pages/cash-flow-prevision/CashFlowPrevisionView"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "BankAccount",
    path: "/bank-account",
    component: () => import("@/views/BankAccount"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  // OPERATION
  {
    name: "CashFlowErpAp",
    path: "/cash-flow-erp-ap",
    component: () => import("@/pages/cash-flow-erp-ap/CashFlowErpApView.vue"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowErpAr",
    path: "/cash-flow-erp-ar",
    component: () => import("@/pages/cash-flow-erp-ar/CashFlowErpArView.vue"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },

  // CAR/CAP

  {
    name: "CashFlowReport",
    path: "/cash-flow-report",
    component: () => import("@/views/CashFlowReport"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowArReport",
    path: "/cash-flow-ar-report",
    component: () => import("@/views/CashFlowArReport"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false, 
    },
  },
  {
    name: "CashFlowApReport",
    path: "/cash-flow-ap-report",
    component: () => import("@/views/CashFlowApReport"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashStatement",
    path: "/cash-statement",
    component: () => import("@/views/CashStatement"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },

  // CASH FLOW

  {
    name: "CashFlowDaily",
    path: "/cash-flow-daily",
    component: () => import("@/views/CashFlowDaily"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowMonthly",
    path: "/cash-flow-monthly",
    component: () => import("@/views/CashFlowMonthly"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowOverview",
    path: "/cash-flow-overview",
    component: () => import("@/views/CashFlowOverview"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowMProjections",
    path: "/cash-flow-monthly-projection",
    component: () => import("@/views/CashFlowMProjections"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowOperational",
    path: "/cash-flow-operational",
    component: () => import("@/views/CashFlowOperational"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowReports",
    path: "/cash-flow-reports",
    component: () => import("@/views/CashFlowReports"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowReportGallery",
    path: "/report-gallery",
    component: () => import("@/views/CashFlowReportGallery"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowDetailedPlanning",
    path: "/detailed-cash-flow-planning",
    component: () => import("@/views/CashFlowDetailedPlanning"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowPlanning",
    path: "/cash-flow-planning",
    component: () => import("@/pages/cash-flow-planning/CashFlowPlanningView"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowGraph1",
    path: "/budget-forecast-graph",
    component: () => import("@/views/CashFlowGraph1"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowGraph2",
    path: "/budget-actual-graph",
    component: () => import("@/views/CashFlowGraph2"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowGraph3",
    path: "/actual-year-graph",
    component: () => import("@/views/CashFlowGraph3"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "CashFlowAbout",
    path: "/cash-flow-about",
    component: () => import("@/views/CashFlowAbout"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  },
  {
    name: "BankAccountYear",
    path: "/bank-account-year",
    component: () => import("@/pages/bank-account-year/BankAccountYearView.vue"),
    meta: {
      requireAuth: true,
      redirectHomeIfLogged: false,
    },
  }
];
